// Creator videos row (sections/cc-ugc.liquid), from website/index.html initUgc(): arrows scroll the row and hide at the ends.
// Reels start loading as soon as the page has finished loading (or earlier if the row gets close), instead of
// waiting for the browser's lazy-load, so they're ready when someone scrolls down.
(() => {
  const load = (f) => {
    if (f.src || !f.dataset.src) return;
    f.addEventListener('load', () => setTimeout(() => f.parentElement.classList.remove('ugc-wait'), 400), { once: true });
    f.src = f.dataset.src;
    setTimeout(() => f.parentElement.classList.remove('ugc-wait'), 8000);
  };
  const loadAll = (sec) => sec.querySelectorAll('iframe[data-src]').forEach(load);
  const reels = (sec) => {
    const near = 'IntersectionObserver' in window && new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { loadAll(sec); near.disconnect(); }
    }), { rootMargin: '1500px 0px' });
    if (near) near.observe(sec);
    const idle = () => (window.requestIdleCallback ? requestIdleCallback(() => loadAll(sec), { timeout: 2000 }) : setTimeout(() => loadAll(sec), 200));
    if (document.readyState === 'complete') idle(); else addEventListener('load', idle, { once: true });
  };
  const init = (sec) => {
    if (!sec || sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const row = sec.querySelector('[data-ugc-row]'), prev = sec.querySelector('.ugc-arrow.prev'), next = sec.querySelector('.ugc-arrow.next');
    reels(sec);
    if (!row) return;
    const ends = () => {
      if (prev) prev.hidden = row.scrollLeft < 8;
      if (next) next.hidden = row.scrollLeft + row.clientWidth > row.scrollWidth - 8;
    };
    sec.querySelectorAll('[data-ustep]').forEach((b) => b.addEventListener('click', () => row.scrollBy({ left: +b.dataset.ustep * row.clientWidth * 0.8, behavior: 'smooth' })));
    row.addEventListener('scroll', ends, { passive: true });
    addEventListener('resize', ends);
    setTimeout(ends, 1500);
    ends();
  };
  const boot = () => document.querySelectorAll('[data-ugc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
